import { Component, OnDestroy, OnInit } from '@angular/core';
import { IUser } from '@geekbears/gb-ngrx-stack-base';

@Component({
  selector: 'app-home',
  templateUrl: './home.container.html',
  styleUrls: ['./home.container.scss'],
})
export class HomeContainer implements OnInit, OnDestroy {
  role: string | null = '';

  constructor() {
    this.getRole();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  getRole() {
    let userData: IUser;
    if (localStorage.getItem('s_user')) {
      userData = JSON.parse(localStorage.getItem('s_user') || '{}');
      if (userData.roles?.find((role) => role == 'super-admin'))
        this.role = 'super-admin';
      else if (userData.roles?.find((role) => role == 'company-manager'))
        this.role = 'company-manager';
      else this.role = 'regular-user';
    }
  }
}
